import ic_loader from "@/assets/images/icons/file_loader.svg";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

const LoaderModal: React.FC = () => {
  const t = useTranslations("CheckoutLoader");
  const tAccessibility = useTranslations("Accessibility");

  return (
    <div className="mx-auto max-h-[90vh] w-[26.3rem] max-w-[80vw] overflow-auto rounded-lg bg-[#FBFBFB] px-4 pb-6 pt-5 text-center shadow-lg md:w-[28.5rem] lg:px-16 lg:pb-10">
      <Image alt={tAccessibility("loadingIconAlt")} className="m-auto mt-4" height={100} src={ic_loader} width={100} />

      <h2 className="mt-1 pl-3 font-raleway text-sm font-semibold leading-10 text-primary tadbeer:text-tadbeerPrimary lg:mb-2 lg:mt-4 lg:pl-0 lg:text-xl">
        {t("title")}
      </h2>
      <p className="text-sm tadbeer:text-tadbeerPrimary lg:text-lg">{t("description")}</p>

      <svg
        className="m-auto mt-6 animate-spin"
        fill="none"
        height="70"
        viewBox="0 0 81 80"
        width="71"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#paint0_angular_178_3283_clip_path)" data-figma-skip-parse="true">
          <g transform="matrix(0 0.04 -0.04 0 40.5 40)">
            <foreignObject height="2039.75" width="2039.75" x="-1019.87" y="-1019.87">
              <div
                style={{
                  background:
                    "conic-gradient(from 90deg,rgba(31, 41, 81, 1) 0deg,rgba(31, 41, 81, 1) 63.243deg,rgba(255, 255, 255, 0) 360deg)",
                  height: "100%",
                  opacity: "1",
                  width: "100%",
                }}
              ></div>
            </foreignObject>
          </g>
        </g>
        <path
          d="M80.5 40C80.5 62.0914 62.5914 80 40.5 80C18.4086 80 0.5 62.0914 0.5 40C0.5 17.9086 18.4086 0 40.5 0C62.5914 0 80.5 17.9086 80.5 40ZM12.4611 40C12.4611 55.4855 25.0145 68.0389 40.5 68.0389C55.9855 68.0389 68.5389 55.4855 68.5389 40C68.5389 24.5145 55.9855 11.9611 40.5 11.9611C25.0145 11.9611 12.4611 24.5145 12.4611 40Z"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.12156862765550613,&#34;g&#34;:0.16078431904315948,&#34;b&#34;:0.31764706969261169,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.12156862765550613,&#34;g&#34;:0.16078431904315948,&#34;b&#34;:0.31764706969261169,&#34;a&#34;:1.0},&#34;position&#34;:0.17567500472068787},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.12156862765550613,&#34;g&#34;:0.16078431904315948,&#34;b&#34;:0.31764706969261169,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.12156862765550613,&#34;g&#34;:0.16078431904315948,&#34;b&#34;:0.31764706969261169,&#34;a&#34;:1.0},&#34;position&#34;:0.17567500472068787},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:4.8985871985824346e-15,&#34;m01&#34;:-80.0,&#34;m02&#34;:80.50,&#34;m10&#34;:80.0,&#34;m11&#34;:4.8985871985824346e-15,&#34;m12&#34;:-4.8985871985824346e-15},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <defs>
          <clipPath id="paint0_angular_178_3283_clip_path">
            <path d="M80.5 40C80.5 62.0914 62.5914 80 40.5 80C18.4086 80 0.5 62.0914 0.5 40C0.5 17.9086 18.4086 0 40.5 0C62.5914 0 80.5 17.9086 80.5 40ZM12.4611 40C12.4611 55.4855 25.0145 68.0389 40.5 68.0389C55.9855 68.0389 68.5389 55.4855 68.5389 40C68.5389 24.5145 55.9855 11.9611 40.5 11.9611C25.0145 11.9611 12.4611 24.5145 12.4611 40Z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default LoaderModal;
